<template>
  <div class="main">
    <report-top
      ><ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool">
      <div v-if="false" slot="item" class="selectToolItem">
        <div class="label">
          <p>报警对象</p>
        </div>
        <select-device
          style="width: 130px"
          :name="searchItem.name"
          @update:name="searchItem.name = $event"
          @update:idList="searchItem.deviceIdList = $event"
          clearable
        ></select-device>
      </div>
      <template slot="btn"
        ><Button @click="exportAll" type="error" class="chaxun">导出</Button
        ><Button @click="chaxun" type="primary" class="chaxun"
          >查询</Button
        ></template
      >
    </selectTool>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var alarmList = [];
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center"
        },
        {
          title: "报警对象",
          key: "name"
        },
        {
          title: "设备号",
          key: "deviceNo"
        },
        {
          title: "单位名称",
          key: "groupName"
        },
        {
          title: "驾驶员",
          key: "driverName"
        },
        {
          title: "报警类型",
          key: "alarmTypeName"
        },
        {
          title: "详细信息",
          key: "info"
        },
        {
          title: "报警时长",
          key: "duration"
        },
        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          }
        },
        {
          title: "开始地点",
          key: "startAdd"
        },
        {
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          }
        },
        {
          title: "结束地点",
          key: "endAdd"
        }
      ],
      tableData: [],
      total: 0,
      searchItem: {
        endTime: 0,
        startTime: 0,
        alarmIdList: [],
        deviceIdList: [],
        //deviceUseType: 0,//0-其他，1-车载，2-人员，3-设施
        pageNumber: 1,
        pageSize: 50,
        keyword: "",
        name: ""
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          type: "lyyymmdd"
        },
        {
          title: "报警类型",
          key: "alarmIdList",
          required: false,
          type: "Select",
          selectItems: alarmList,
          multiple: true,
          selectType: "obj"
        },
        {
          title: "选择车辆",
          key: "deviceIdList",
          type: "selectAlotCar"
        }
      ]
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");

      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarm/list",
        data: this.searchItem
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          for (let i = 0; i < data.length; i++) {
            data[i].name = aa([data[i].carNo, data[i].personName]);
            data[i].duration = this.utils.duration(data[i].duration);
          }
          this.tableData = data;
          function aa(t) {
            for (let j = 0; j < t.length; j++) {
              if (t[j] != null) {
                return t[j];
              }
            }
          }
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList
        },
        {
          name: "startTime",
          value: this.searchItem.startTime
        },
        {
          name: "endTime",
          value: this.searchItem.endTime
        }
      ];
      this.utils.exportData(
        this.axios.ipPort + "/cloud-common-server-alarm/alarm/export",
        params
      );
    },
    search() {
      this.getList();
    },
    reAlarmList(v) {
      this.alarmIdList = v;
      this.getList();
    },
    reTimeObj(x) {
      this.timeObj = x;
      this.getList();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    getDictionary() {
      alarmList.length = 0;
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmType"
        }
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        var data = JSON.parse(res.data.data.value);

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name
          };
          alarmList.push(obj);
        }
        //this.forms[1].selectItems = arr;
      });
    }
  },
  mounted() {
    this.getDictionary();
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.chaxun();
    }, 200);
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/alarm/alarmNotice.vue